module.exports = __webpack_public_path__ + "static/media/mem5YaGs126MiZpBA-UNirkOXuhpOqc.3648eede.woff2";